import * as types from './label.types';
import * as constants from './label.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const labelReducer = generateResourceReducer<types.ILabel>({
  STORE: constants.STORE_LABEL,
  CLEAR: constants.CLEAR_LABEL,
});
